import { CommandButton, CommandButtonGroup } from "@remirror/react-ui";
import { useCallback } from "react";
import { useActive } from "@remirror/react";
import { useLinkState } from "../../../hooks/useLinkState";

type Props = {
  nodeId: string;
};

export function LinkButton({ nodeId }: Props) {
  const { clickEdit } = useLinkState(nodeId);
  const active = useActive();
  const activeLink = active.link();

  const handleClickEdit = useCallback(() => {
    clickEdit();
  }, [clickEdit]);

  return (
    <CommandButtonGroup>
      <CommandButton
        aria-label={activeLink ? "Edit link (⌘K)" : "Insert link (⌘K)"}
        active={activeLink}
        commandName="updateLink"
        onSelect={handleClickEdit}
        icon="link"
        enabled
      />
    </CommandButtonGroup>
  );
}
